<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="4" :sm="12">
            <a-form-item label="月份">
              <a-select placeholder="请选择" v-model="queryParam.month">
                <a-select-option value="01">1月</a-select-option>
                <a-select-option value="02">2月</a-select-option>
                <a-select-option value="03">3月</a-select-option>
                <a-select-option value="04">4月</a-select-option>
                <a-select-option value="05">5月</a-select-option>
                <a-select-option value="06">6月</a-select-option>
                <a-select-option value="07">7月</a-select-option>
                <a-select-option value="08">8月</a-select-option>
                <a-select-option value="09">9月</a-select-option>
                <a-select-option value="10">10月</a-select-option>
                <a-select-option value="11">11月</a-select-option>
                <a-select-option value="12">12月</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="4" :sm="10">
            <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;height:40px;">
        <span style="float:right; ">金额单位：万元</span>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="itemSlot" slot-scope="item">
          <span v-if="item.level===1">{{item.text}}</span>
          <span v-if="item.level===2" style="margin-left:0px;">{{item.text}}</span>
          <span v-if="item.level===3" style="margin-left:45px;">{{item.text}}</span>
        </template>
      </a-table>

    </div>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { toDecimal } from '@/utils/util'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction, postAction } from '@/api/manage'
  import {getDictItemsFromCache} from '@/api/api'

  export default {
    name: 'BizLifeReport',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
    },
    data () {
      return {
        description: '咨询业务报表', //所有机构人身险
        disableMixinCreated: true,
        columns: [
          {
            title: '序号',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'项目',
            className: 'column-text',
            scopedSlots: {customRender: 'itemSlot'}
          },
          {
            title:'德州',
            className: 'column-money',
            dataIndex: 'A03A08A04',
          },
          {
            title:'枣庄',
            className: 'column-money',
            dataIndex: 'A03A08A07',
          },
          {
            title:'临沂',
            className: 'column-money',
            dataIndex: 'A03A08A12',
          },
          {
            title:'淄博',
            className: 'column-money',
            dataIndex: 'A03A08A03',
          },
          {
            title:'青岛',
            className: 'column-money',
            dataIndex: 'A03A08A13',
          },
          {
            title:'滨城',
            className: 'column-money',
            dataIndex: 'A03A08A08',
          },
          {
            title:'总部',
            className: 'column-money',
            dataIndex: 'A03'
          },
          {
            title:'合计',
            className: 'column-money',
            dataIndex: 'HJ',
          },
        ],
        url: {
          list: "/bms/regulatoryReport/consultReport",
        },
      }
    },
    created() {
    },
    methods: {
      searchQuery(){
        if(this.queryParam.month){
          this.loadData()
        }
      },
      loadData() {
        this.loading = true;

        let year = new Date().getFullYear()
        let param = {year: year, month: this.queryParam.month}
        this.dataSource = this.transferData();
        /*以invoice_time字段进行比较，即财务开票日期归属到不同月份*/
        postAction(this.url.list, param).then((res) => {
          if (res.success) {
            this.dataSource = this.transferData(res.result);
          }
          if (res.code === 510) {
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },

      // 把后台返回数据进行格式转换
      transferData(resultData){
        if(!resultData){
          return;
        }

        // 总部寿险数据，顺序是确定的, level是报表中的级次，显示用
        let consultData = [
          {text:'财产保险',level:1, insuranceTypeCode:'CCX', A03:0.00, A03A08A03:0.00, A03A08A12:0.00, A03A08A13:0.00,A03A08A04:0.00,A03A08A07:0.00,A03A08A08:0.00, HJ:0.00},
          {text:'人身保险',level:2, insuranceTypeCode:'RSX', A03:0.00, A03A08A03:0.00, A03A08A12:0.00, A03A08A13:0.00, A03A08A04:0.00,A03A08A07:0.00,A03A08A08:0.00, HJ:0.00},
          {text:'总计',level:1, insuranceTypeCode:'ZJ', A03:0.00, A03A08A03:0.00, A03A08A12:0.00, A03A08A13:0.00, A03A08A04:0.00,A03A08A07:0.00,A03A08A08:0.00, HJ:0.00}];

        // 赋值结果集, 一次赋值各组织机构
        for(let i=0; i<resultData.length; i++){
          let money = resultData[i];
          for(let j=0; j<consultData.length; j++){
            if(consultData[j].insuranceTypeCode == money.insuranceTypeCode){
              consultData[j][money.orgCode] = money.invoiceAmount
              break; //退出内层循环
            }
          }
        }

        //计算求和, 根据报表公司直接求和
        consultData[2].A03 = consultData[0].A03 + consultData[1].A03
        consultData[2].A03A08A03 = consultData[0].A03A08A03 + consultData[1].A03A08A03
        consultData[2].A03A08A12 = consultData[0].A03A08A12 + consultData[1].A03A08A12
        consultData[2].A03A08A13 = consultData[0].A03A08A13 + consultData[1].A03A08A13
        consultData[2].A03A08A04 = consultData[0].A03A08A04 + consultData[1].A03A08A04
        consultData[2].A03A08A07 = consultData[0].A03A08A07 + consultData[1].A03A08A07
        consultData[2].A03A08A08 = consultData[0].A03A08A08 + consultData[1].A03A08A08
        // 计算合计数
        for(let i=0; i<3; i++){
          consultData[i].HJ = consultData[i].A03 + consultData[i].A03A08A03 + consultData[i].A03A08A12
            + consultData[i].A03A08A13 + consultData[i].A03A08A04 + consultData[i].A03A08A07 + consultData[i].A03A08A08
        }

        // 保留2位小数
        for(let i=0; i<consultData.length; i++){
          consultData[i].A03 =  toDecimal(consultData[i].A03)
          consultData[i].A03A08A03 =  toDecimal(consultData[i].A03A08A03)
          consultData[i].A03A08A12 =  toDecimal(consultData[i].A03A08A12)
          consultData[i].A03A08A13 =  toDecimal(consultData[i].A03A08A13)
          consultData[i].A03A08A04 =  toDecimal(consultData[i].A03A08A04)
          consultData[i].A03A08A07 =  toDecimal(consultData[i].A03A08A07)
          consultData[i].A03A08A08 =  toDecimal(consultData[i].A03A08A08)
          consultData[i].HJ = toDecimal(consultData[i].HJ)
        }

        return consultData;
      },

      getMoney(resultData, code){
        for(let i=0; i<resultData.length; i++){
          if(resultData[i].insuranceTypeCode == code){
            return resultData[i];
          }
        }
        //没有找到返回null
        return null;
      },
    }
  }
</script>
<style>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>
